/**
 * MobileSidebarSheet — wrappt die existierende Sidebar in ein vaul-Drawer
 * (left direction). Wird auf Mobile durch den Topbar-Hamburger geöffnet.
 *
 * State kommt aus SidebarContext.useSidebar().
 *
 * iOS-feeling: vaul gibt uns Drag-to-dismiss + Snap-Points + Backdrop.
 */
import { Drawer } from "vaul";
import { Sidebar } from "@/components/layout/Sidebar";
import { useSidebar } from "@/contexts/SidebarContext";
import { cn } from "@/lib/utils";

export function MobileSidebarSheet() {
  const { open, setOpen } = useSidebar();

  return (
    <Drawer.Root
      open={open}
      onOpenChange={setOpen}
      direction="left"
      shouldScaleBackground={false}
    >
      <Drawer.Portal>
        <Drawer.Overlay className="fixed inset-0 z-50 bg-black/40 md:hidden" />
        <Drawer.Content
          className={cn(
            "fixed inset-y-0 left-0 z-50 flex h-full max-w-[85vw] outline-none md:hidden",
            "bg-bg-surface",
            // Safe-Area-Inset auf iOS-Geräten mit Home-Indicator: Sidebar-Footer
            // (z.B. User-Pill) wird sonst von der System-Bar überlappt.
            "pb-[env(safe-area-inset-bottom)]",
          )}
        >
          <Drawer.Title className="sr-only">Hauptnavigation</Drawer.Title>
          <Drawer.Description className="sr-only">
            Navigiere zu allen PayPilot-Bereichen
          </Drawer.Description>
          {/* Sidebar nimmt im Sheet die natürliche Breite ein.
           * variant="mobile" setzt einen distinct motion.layoutId-Scope, damit
           * Active-Bar-Animationen nicht mit der parallel gemounteten
           * Desktop-Sidebar kollidieren. */}
          <div className="h-full">
            <Sidebar variant="mobile" />
          </div>
          {/* Drag-Handle an der rechten Kante */}
          <div className="my-auto h-12 w-1.5 rounded-full bg-border-strong mx-1.5" />
        </Drawer.Content>
      </Drawer.Portal>
    </Drawer.Root>
  );
}
